import { useWizard } from '@insify/funnel-components';
import { useDebouncedCallback } from '@insify/react-hooks';
import { useEffect, useRef, useState } from 'react';

import { useCommands } from '../../hooks/useCommands';
import { useParamsQuery } from '../../hooks/useQueries';

export const useActivityEventHandlers = () => {
  const { showPreviousPage, showNextPage } = useWizard();
  const { sendCommandAndWaitForInvalidations } = useCommands();
  const [numCommandsInProgress, setNumCommandsInProgress] = useState<number>(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: quoteParams } = useParamsQuery();
  const lastSearchQuery = useRef('');
  const handleSearchActivity = useDebouncedCallback((searchString: string) => {
    if (searchString !== '' && searchString !== lastSearchQuery.current) {
      void sendCommandAndWaitForInvalidations({
        type: 'searchActivities',
        payload: { query: searchString },
      });
    }
    lastSearchQuery.current = searchString;
  }, 500);

  const onSubmit = () => {
    setIsSubmitting(true);
  };

  const eventHandlers = {
    onAddActivity: async (insifyActivityCode: string) => {
      setNumCommandsInProgress((prev) => (prev ?? 0) + 1);
      await sendCommandAndWaitForInvalidations({
        type: 'addActivity',
        payload: { insifyActivityCode },
      });
      setNumCommandsInProgress((prev) => prev - 1);
    },
    onRemoveActivity: async (insifyActivityCode: string) => {
      setNumCommandsInProgress((prev) => (prev ?? 0) + 1);
      await sendCommandAndWaitForInvalidations({
        type: 'removeActivity',
        payload: { insifyActivityCode },
      });
      setNumCommandsInProgress((prev) => prev - 1);
    },
    onSearchActivity: handleSearchActivity,
    onBack: showPreviousPage,
    onSubmit,
  };

  useEffect(() => {
    if (numCommandsInProgress === 0 && isSubmitting && (quoteParams?.activities?.length ?? 0) !== 0) {
      showNextPage();
    }
  }, [numCommandsInProgress, isSubmitting, quoteParams?.activities?.length]);

  return { ...eventHandlers, isSubmitting };
};
